namespace app.upgraded {

    export interface IUpgradedFrameScope extends ng.IScope {
        api: {};
    }

    export class UpgradedFrame implements ng.IDirective {

        public restrict: string = "A";
        public scope = {
            parentUrl: "=stfUpgradedFrame",
            stateChangeRequest: "=stfUpgradedFrameStateChangeRequest"
        };

        public static factory() {
            return (upgradedCommunicationService: UpgradedCommunicationService, $stateParams: ng.ui.IStateParamsService) => {
                "ngInject";
                return new UpgradedFrame(upgradedCommunicationService, $stateParams);
            };
        }

        public constructor(private upgradedCommunicationService: UpgradedCommunicationService, private $stateParams: ng.ui.IStateParamsService) {
            
        }

        public link(scope: IUpgradedFrameScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
            let iframe: HTMLIFrameElement = <HTMLIFrameElement>element[0];
            let iframeElementContentWindow = () => {
                return iframe.contentWindow;
            };

            iframe.addEventListener("load", () => {
                iframeElementContentWindow().postMessage({"type": "upgraded", "operation": "load-upgraded-css"}, "*");
                this.upgradedCommunicationService.setUi2AlreadyLoaded(true);
            });
            
            scope.$watch("stateChangeRequest.request", (newVal: any) => {
                if (newVal) {
                    iframeElementContentWindow().postMessage({"type": "upgraded", "operation": "changeUrl", "data": newVal.url}, "*");
                }
            });
            
            scope.$on("upgraded:callback", (event, data) => {
                iframeElementContentWindow().postMessage({"operation": "callback", "data": {id: data.id, data: data.data}}, "*");
            });
        }

    }

    angular.module("app.upgraded").directive("stfUpgradedFrame", UpgradedFrame.factory());

}